//./plugins/posthog.js
import posthog from "posthog-js";

export default {
  install(app: any) {
    app.config.globalProperties.$posthog = posthog.init(
        import.meta.env.VITE_POST_HOG_KEY, {
        api_host: import.meta.env.VITE_POST_HOG_API_HOST,
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      }
    );
  },
};
